import {
  StateNodeConfig,
  BaseActionObject,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const getScoresByStudentTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getScoresByStudent",
    src: "getScoresByStudent",
    onDone: {
      target: "idle",
      actions: assign((_ctx, evt) => ({
        scoresByStudentData: evt.data || {
          headers: [],
          students: []
        }
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<Error>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getScoresByStudent", {
            errorReason: evt.data?.message,
            messageData: ["get the scores by student"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
